/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Save_Project_Dialog_TitleInputs */

const en_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Project`)
};

const fr_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le projet`)
};

const de_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt speichern`)
};

const it_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva progetto`)
};

const ru_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить проект`)
};

const es_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar proyecto`)
};

const zh_cn2_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存项目`)
};

const ja_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを保存`)
};

const hi_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट बचाओ`)
};

const pt_pt2_shortcut_keys_save_project_dialog_title = /** @type {(inputs: Shortcut_Keys_Save_Project_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar projeto`)
};

/**
* | output |
* | --- |
* | "Save Project" |
*
* @param {Shortcut_Keys_Save_Project_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_save_project_dialog_title = /** @type {((inputs?: Shortcut_Keys_Save_Project_Dialog_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Save_Project_Dialog_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_save_project_dialog_title(inputs)
	if (locale === "de") return de_shortcut_keys_save_project_dialog_title(inputs)
	if (locale === "it") return it_shortcut_keys_save_project_dialog_title(inputs)
	if (locale === "ru") return ru_shortcut_keys_save_project_dialog_title(inputs)
	if (locale === "es") return es_shortcut_keys_save_project_dialog_title(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_save_project_dialog_title(inputs)
	if (locale === "ja") return ja_shortcut_keys_save_project_dialog_title(inputs)
	if (locale === "hi") return hi_shortcut_keys_save_project_dialog_title(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_save_project_dialog_title(inputs)
	return en_shortcut_keys_save_project_dialog_title(inputs)
});